import { render, staticRenderFns } from "./incident-impact-icon.vue?vue&type=template&id=04cf0f7c"
import script from "./incident-impact-icon.vue?vue&type=script&lang=js"
export * from "./incident-impact-icon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports